import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { STAGES } from "../lib/stages";
import { api } from "../lib/api";
import { toast } from "sonner";

const empty = { name: "", email: "", phone: "", company: "", stage: "new_lead", setup_fee: 0, monthly_value: 0 };

export default function AddProspectModal({ open, onOpenChange, onCreated }) {
  const [form, setForm] = useState(empty);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Name is required");
    const { data } = await api.post("/prospects", {
      ...form,
      setup_fee: Number(form.setup_fee) || 0,
      monthly_value: Number(form.monthly_value) || 0,
    });
    onCreated(data);
    setForm(empty);
    onOpenChange(false);
  };

  const inputCls =
    "w-full bg-black/30 border border-white/10 rounded-md px-3 py-2 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-[#4690d9]";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-panel border-white/10 max-w-md" data-testid="add-prospect-modal">
        <DialogHeader>
          <DialogTitle className="text-white">Add Prospect</DialogTitle>
          <DialogDescription className="text-slate-400 text-sm">Manually register a new lead in the pipeline.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="add-name-input" placeholder="Full name *" value={form.name} onChange={set("name")} className={inputCls} />
          <input data-testid="add-email-input" type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="add-phone-input" placeholder="Phone" value={form.phone} onChange={set("phone")} className={inputCls} />
            <input data-testid="add-company-input" placeholder="Company / website" value={form.company} onChange={set("company")} className={inputCls} />
          </div>
          <div>
            <label className="text-xs text-slate-500 block mb-1">Stage</label>
            <select data-testid="add-stage-select" value={form.stage} onChange={set("stage")} className={inputCls}>
              {STAGES.map((s) => (
                <option key={s.value} value={s.value} className="bg-[#0f2442]">{s.label}</option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-slate-500 block mb-1">Setup fee — one-time ($)</label>
              <input data-testid="add-setup-fee-input" type="number" min="0" value={form.setup_fee} onChange={set("setup_fee")} className={inputCls} />
            </div>
            <div>
              <label className="text-xs text-slate-500 block mb-1">Monthly ($ / mo)</label>
              <input data-testid="add-monthly-input" type="number" min="0" value={form.monthly_value} onChange={set("monthly_value")} className={inputCls} />
            </div>
          </div>
          <button
            data-testid="add-prospect-submit-btn"
            type="submit"
            className="w-full py-2.5 rounded-full bg-[#4690d9] hover:bg-[#5a9fe0] text-white font-semibold transition-colors"
          >
            Add to Pipeline
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
